import { Typography } from "antd";

const { Title } = Typography;

interface HeadingBlockProps {
	level: 2 | 3;
	text: string;
}

export default function HeadingBlock({ level, text }: HeadingBlockProps) {
	return (
		<Title level={level} style={{ marginTop: level === 2 ? 24 : 16, marginBottom: 8 }}>
			{text}
		</Title>
	);
}
